import { useTranslation as useReactI18NextTranslation } from 'react-i18next'

export const useTranslation = (nsOrPlaceholder?: string | boolean) => {
    const translatePlaceholder = (
        _: string,
        fallback?: string | Record<string, string | number>,
    ) => {
        if (typeof fallback === 'string') {
            return fallback
        }
        return ''
    }

    const placehoderResponse = () => ({
        t: translatePlaceholder,
        ready: true,
        i18n: '',
    })

    const namespace = typeof nsOrPlaceholder === 'string' ? nsOrPlaceholder : undefined
    const usePlaceholder = typeof nsOrPlaceholder === 'boolean' ? nsOrPlaceholder : false

    const i18NextTranslation = useReactI18NextTranslation(namespace)

    return usePlaceholder ? placehoderResponse() : i18NextTranslation
}

export default useTranslation
